/**
 * Intercom Fin (Messenger) chat integration.
 * Provides openChat to open the Intercom messenger; used when Settings.intercom.enabled is true
 * We guard on window and window.Intercom so we don't throw if the widget script hasn't loaded yet.
 */

export const openChat = () => {
  if (typeof window !== 'undefined' && typeof window.Intercom === 'function') {
    window.Intercom('show')
  }
}
